import React , { useState , useRef  }from 'react'


import { useNavigate  } from "react-router-dom";


import { Button } from 'primereact/button';
import { InputText } from 'primereact/inputtext';
import { Password } from 'primereact/password';
import { Message } from 'primereact/message';
import { ProgressSpinner } from 'primereact/progressspinner';
import { Toast } from 'primereact/toast';

import { ApiCallPost } from '../../../../../../ApiCall/ApiCall';



function DialogLogin( { crear , answer }) {

    const [inputValue,setInputValue] = useState( null )
    const [logError,setLogError] = useState( false )
    const [loggin,setLoggin] = useState( false )
    const [textError,setTextError] = useState( "")

    const toast = useRef()

    function onCrearCuenta()
    {
        console.log( "onCrearCuenta")
        crear()
    }

    function onLogin()
    {
        //setTextError( "Error en el Login")
        //setLogError( true ) ;

        console.log( "onLogin")

        var email = document.getElementById( "username").value ;
        

        //console.log( "email = " + email + " password = " + inputValue )

        if ( email===""||inputValue==="")
        {
           toast.current.show({ severity: 'warn', summary: 'Faltante', detail: 'No se capturaron datos completos', life: 9000 });
           return ;

        }

        var obj = {
            client_email : email ,
            client_password : inputValue
        }

        //console.log( "client_login = " , obj )

        //return ;

        ApiCallPost( "/client_login" , obj )
        .then((response)=>{
            console.log( "Response = " , response )

            answer( response ) ; // Mandamos la respuesta
        })
        .catch((err) => {
            console.log( err )
            return ;
        })

    }

    function setTheInputValue( value )
    {
        console.log( "setTheImputValue" ) ;

        setInputValue( value )
    }



  return (
    

        <div className='card' style={{backgroundColor:'#f9fafb'}}>

            <div>
                <h2>Inicio de Sesión</h2>
            </div>
            

        <div className="flex flex-columna md:flex-row">
            <div className="w-full md:w-12 flex flex-column align-items-center justify-content-center gap-3 py-5">
                <div className="flex flex-wrap justify-content-center align-items-center gap-2">
                    <label className="w-5rem">Correo</label>
                    <InputText id="username" type="text" onFocus={() => setLogError(false )}
                    className="md:w-12" style={{border:'1px solid', borderColor : 'purple'}}/>
                </div>

                {/* w-12rem  md:w-12*/}
                <div className="flex flex-wrap justify-content-center align-items-center gap-2">
                    <label className="md:w-4">Contraseña</label>
                    <Password className=""  value={inputValue} onChange={(e) => setTheInputValue(e.target.value)} style={{border:'1px solid', borderColor : 'purple'}}
                        id='password' onFocus={() => setLogError(false )}
                        promptLabel="Teclee un Password" weakLabel="Muy simple" mediumLabel="Complejidad Mediana" strongLabel="Password Complejo" toggleMask />
                </div>
                <div>
                <a className="crt-account" 
                    onClick={onCrearCuenta} style={{cursor:'grab'}} >Crear cuenta</a>
                </div>

                <Button label="Login" icon="pi pi-user" onClick={onLogin}
                    className="w-10rem mx-auto"></Button>

                    {
                        logError && (
                            <div  className="w-12rem m-4">

                                <Message onClick={() => setLogError(false )} severity="error" text={textError}/>


                            </div>
                        )
                    }

                    {
                        loggin && (
                            <ProgressSpinner style={{width: '50px', height: '50px'}}/>
                        )
                    }

            </div>

        </div>

        <Toast ref={toast} />

        </div>

                )

}

export default DialogLogin
